import { Navigate, useSearchParams } from "react-router-dom";
import type { ProjectTypeId } from "../lib/projectFilters";
import { typeToPortfolioSlug } from "../lib/portfolioRoutes";

const TYPE_QUERY_MAP: Record<string, ProjectTypeId> = {
  "product-design": "product-design",
  "mobile-design": "mobile-design",
  "web-design": "web-design",
  "motion-design": "motion-design",
  identity: "identity",
};

/** Redirects /projects?type=... to /ux-portfolio/{category}/ */
export function PortfolioQueryRedirect(): JSX.Element {
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get("type");

  if (typeParam && TYPE_QUERY_MAP[typeParam]) {
    const slug = typeToPortfolioSlug(TYPE_QUERY_MAP[typeParam]);
    return <Navigate to={`/ux-portfolio/${slug}`} replace />;
  }

  return <Navigate to="/ux-portfolio" replace />;
}
